<template>
    <div class="header">
        <div class="header__inner">
            <img 
                @click="redirectToMain"
                src="../images/logo.svg" 
                class="header__logo">
            <div
                :class="{show: isActive}" 
                class="header__wrapper">
                <div class="header__search search">
                    <input 
                        placeholder="Какой букет Вас интересует?" 
                        class="search__field" 
                        @keyup.enter="search"
                        v-model="searchValue">
                    <button
                        type="button" 
                        @click="search" 
                        class="search__button"></button>
                </div>

                <nav class="header__navigation navigation">
                    <router-link to="/catalog" class="navigation__item">каталог</router-link>
                    <router-link 
                        @click="selectAbout"
                        :to="{path: '/', hash: '#about'}" 
                        class="navigation__item">о нас</router-link>
                    <router-link to="/contacts" class="navigation__item navigation__item_mob">Контакты</router-link>
                    <router-link to="/delivery" class="navigation__item">Доставка и оплата</router-link>
                </nav>

                <div class="header__controlls header-controlls">
                    <div class="header__tel-body">
                        <div class="header__tel-wrapper tel">
                            <a href="tel:+79218077750" class="header__tel header__btn"></a>
                            <p class="header-controlls__info">
                                <a href="tel:+79218077750" class="header__tel-tel">+7(921)807-77-50</a>
                                По вопросам наличия или заказа в конкретном магазине, обращайтесь по номеру из раздела <router-link class="header-controlls__link" to="/contacts">контакты</router-link>
                            </p>
                        </div>
                    </div>
                    

                    <button
                        @click="openPopup"
                        class="header__lk header__btn"></button>

                    <router-link to="/cart" class="cart header__cart">
                        <span class="cart__quantity">{{CART.length}}</span>
                        <span class="cart__total">{{cartTotal}} ₽</span>
                    </router-link>
                </div>
            </div>

            <div 
                class="burger-ico" 
                :class="{menuOpen: isActive}"
                @click="toggleBurger">
                    <span class="burger-ico__item"></span>
            </div>

            <div 
                class="cart-ico-mobile"
                 @click="openCart"
                 v-if="this.$route.name != 'Cart-page'"
                 :class="{showCartIco:isShowCartIco}">
                 <span class="cart-ico-mobile__quantity">{{CART.length}}</span>
            </div>
        </div>
        <LoginPopup
            v-if="isLogin"
            @closePopup= "closePopup"
            @selectRegistration= "selectRegistration"/>
        <RegistrationPopup
            v-if="isRegistration"
            @closePopup= "closePopup"
            @selectLogin= "selectLogin"
            @success = "success"/>
        <SuccesssPopup
            v-if="isSuccess"
            />
    </div>
</template>

<script>
import LoginPopup from '@/components/popups/Login-popup'
import RegistrationPopup from '@/components/popups/Registration-popup'
import SuccesssPopup from '@/components/popups/Success-popup'
import {mapGetters, mapActions} from 'vuex'

export default {
    data() {
        return {
            searchValue: '',
            isActive: false,
            isShowCartIco: '',
            isActive: false,
            isLogin: false,
            isRegistration: false,
            isSuccess: false
        }
    },
    components: {
        LoginPopup,
        RegistrationPopup,
        SuccesssPopup
    },
    computed: {
        ...mapGetters([
            'CART'
        ]),
        cartTotal(){
            let result = [0]
            for (let item of this.CART){
                result.push(item.price * item.quantity)
            }
            result = result.reduce(function (sum, el){
                return sum + el;
            })
            return result;
        }
    },
    methods: {
        ...mapActions([
            'GET_SEARCH_VALUE',
            'RESET_PAGE_NUMBER',
            'GET_CATEGORY_VALUE',
            'RESET_CATEGORY',
            'GET_PRODUCTS'
        ]),
        search(){
            this.GET_SEARCH_VALUE(this.searchValue)
            this.RESET_PAGE_NUMBER()
            this.GET_CATEGORY_VALUE('')
            this.RESET_CATEGORY()
            this.GET_PRODUCTS()
            this.$router.push('/catalog')
            document.body.style.overflowY = 'scroll'
            this.isActive = false
        },
        redirectToMain(){
            this.$router.push('/')
        },
        openCart(){
            this.$router.push('/cart')
        },
        handleScroll(){
            if(window.pageYOffset >= 400 && window.innerWidth <= 600){
                this.isShowCartIco = true
            }else{
                this.isShowCartIco = false
            }
        },
        selectAbout(){
            this.isActive = false
            document.body.style.overflowY = 'scroll'
        },
        toggleBurger(){
            this.isActive = !this.isActive
            if (this.isActive) {
                document.body.style.overflowY = 'hidden'
            }else{
                document.body.style.overflowY = 'scroll'
            }
        },
        closePopup(bool){
            this.isLogin = bool
            this.isRegistration = bool
        },
        openPopup(){
            this.toggleBurger()
            this.isLogin = true
            let cookie = document.cookie.match(/token=(.+?)(;|$)/)
            let role = localStorage.getItem('role')
            if(cookie && role == 'user'){
                this.$router.push('/account')
            }else if(cookie && role == 'admin'){
                this.$router.push('/admin')
            }
        },
        selectRegistration(){
            this.isLogin = false
            this.isRegistration = true
        },
        selectLogin(){
            this.isLogin = true
            this.isRegistration = false
        },
        success(){
            this.isRegistration = false
            this.isSuccess = true
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    }
}
</script>

<style scoped>
    .header__inner{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 25px;
        padding-bottom: 25px;
    }
    .header__logo{
        cursor: pointer;
    }
    .header__wrapper{
        display: flex;
        align-items: center;
        width: 100%;
    }
    .header__navigation{
        display: flex;
        align-items: center;
        margin-right: 80px;
    }
    .navigation__item{
        position: relative;
        margin-right: 50px;
        font-size: 15px;
        font-family: 'Romul';
    }
    .navigation__item::before{
        position: absolute;
        content: "";
        bottom: -3px;
        right: 0;
        width: 0%;
        transition: .2s;
        height: 1px;
        background-color: #000;
    }
    .navigation__item:last-child{
        margin-right: 0;
    }
    .navigation__item:hover::before{
        width: 100%;
        left: 0;
    }
    .header__controlls{
        display: flex;
        align-items: center;
    }
    .header__tel-body{
        position: relative;
        height: 36px;
        width: 36px;
        margin-right: 35px;
    }
    .header-controlls__info{
        position: absolute;
        top: -10px;
        right: -10px;
        color: #938D88;
        background-color: #e9ded6;
        padding: 10px;
        padding-right: 55px;
        border-radius: 8px;
        width: 280px;
        display: none;
    }
    .header-controlls__link{
        color: #938D88;
    }
    .header-controlls__link:hover{
        text-decoration: none;
        color: #b9aea6;
        transition: all linear .2s;
    }
    .header__tel-tel{
        display: block;
        color: #938D88;
        margin-bottom: 10px;
        text-decoration: underline;
    }
    .header__tel-tel:hover{
        text-decoration: none;
        color: #b9aea6;
        transition: all linear .2s;
    }
    .header__tel-body:hover .header-controlls__info{
        display: block;
    }
     /* Поиск */
    .header__search{
        display: flex;
        margin-left: auto;
        width: 100%;
        max-width: 320px;
        border-radius: 47px;
        border: 1px solid #ECDED3;
        transition: all linear .2s;
        margin-right: 90px;
    }
    .header__search:hover{
        border-color: #000;
    }
    .search__field{
        border: none;
        padding: 12px 20px;
        width: 100%;
        height: 100%;
        transition: all linear .1s;
        background-color: transparent;
        color: #000;
        font-family: 'Romul';
        font-size: 12px;
    }
    .search__field:focus{
        outline: none;
    }
    .search__button{
        background: none;
        border: none;
        width: 50px;
        background: url(../images/icons/search-ico.svg) no-repeat;
        background-position: center;
        transition: all linear .2s;
    }
    .search__button:hover{
        opacity: .5;
    }
    /* телефон */
    /* .header__tel-wrapper{
        position: relative;
        height: 36px;
        margin-right: 35px;
    }
    .header__tel-wrapper::before{
        position: absolute;
        content: "+7(921)807-77-50";
        color: #938D88;
        height: 100%;
        width: 195px;
        border-radius: 50px;
        background-color: #e9ded6;
        z-index: 1;
        top: 0;
        right: calc(100% - 35px);
        padding: 7px 10px;
        transition: all linear .2s;
        display: none;
    }
    .header__tel-wrapper:hover::before{
        display: block;
    } */
    .header__tel{
        position: relative;
        display: inline-block;
        background: #ECDED3 url(../images/icons/tel-ico.svg) no-repeat;
        background-position: center;
        transition: all linear .2s;
        z-index: 20;
        border-radius: 50%;
        height: 36px;
        width: 36px;
    }
    .header__tel-wrapper:hover .header__tel{
        background-color: #b9aea6;
    }
    .header__lk{
        background: #ECDED3 url(../images/icons/lk-ico.svg) no-repeat;
        margin-right: 35px;
        background-position: center;
        transition: all linear .2s;
        border-radius: 50%;
        height: 36px;
        width: 36px;
    }
    .header__lk:hover{
        opacity: .5;
    }
    .header__cart{
        position: relative;
        height: 30px;
        width: 38px;
        background: url(../images/icons/cart-ico.svg) no-repeat;
        background-size: contain;
    }
    .header__cart:hover{
        opacity: .8;
    }
    .header__cart:hover .cart__total{
        transform: scale(1);
    }
    .cart__total{
        position: absolute;
        bottom: -42px;
        left: -20px;
        font-size: 14px;
        padding: 5px 15px;
        border-radius: 47px;
        background-color: #ECDED3;
        min-width: 85px;
        text-align: center;
        font-weight: 600;
        transform: scale(0);
        transition: transform linear .1s;
    }
    .cart__quantity{
        position: absolute;
        display: block;
        height: 18px;
        width: 18px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        line-height: 13px;
        border-radius: 50%;
        color: #fff;
        background-color: #514E47;
        bottom: -10px;
        right: -5px;
    }
    /* бургер */
    .burger-ico{
        display: none;
        align-items: center;
        padding-left: 5px;
    }
    .burger-ico__item{
        position: relative;
        width: 40px;
        height: 2px;
        background-color: #000;
    }
    .burger-ico__item::before{
        content: "";
        position: absolute;
        background-color: #000;
        width: 40px;
        height: 2px;
        transform: translate(0, 10px);
        transition: all ease .2s;
    }
    .burger-ico__item::after{
        content: "";
        position: absolute;
        background-color: #000;
        width: 40px;
        height: 2px;
        transform: translate(0, -10px);
        transition: all ease .2s;
    }
    .menuOpen span{
        transform: rotate(45deg);
    }
    .menuOpen span::before{
        transform: rotate(-90deg);
    }
    .menuOpen span::after{
        transform: translate(0);
    }
    .cart-ico-mobile{
        display: none;
        position: fixed;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, .75);
        background-image: url(../images/icons/cart-ico.svg);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 55%;
        top: 30px;
        right: 20px;
        z-index: 50;
    }
    .cart-ico-mobile__quantity{
        position: absolute;
        right: 1px;
        bottom: 50%;
        margin-bottom: -9px;
    }
    .showCartIco{
        display: block;
    }
    .header-controlls__link{
        text-decoration: underline;
    }
    .navigation__item_mob{
        display: none;
    }
    @media (max-width: 992px) {
        .header__logo{
            margin-right: 20px;
        }
        .navigation__item{
            font-size: 12px;
            text-align: center;
        }
        .header__search{
            margin-right: 30px;
        }
        .navigation__item{
            margin-right: 30px;
        }
        .header__navigation{
            margin-right: 30px;
        } 
    }
    @media (max-width: 768px){
        .header__inner{
            position: relative;
            padding-top: 10px;
            padding-bottom: 10px;
        }
        .header__wrapper{
            position: fixed;
            display: none;
            top: 63px;
            left: 0;
            flex-direction: column;
            align-items: center;
            z-index: 1000;
            background-color: #fff;
            padding-top: 30px;
            padding-bottom: 30px;
            border-radius: 0 0 20px 20px;
            box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
        }
        .header__search{
            margin-left: 0;
            margin-right: 0;
            max-width: none;
            margin-bottom: 50px;
        }
        .header__navigation{
            flex-direction: column;
            margin-right: 0;
        }
        .navigation__item{
            margin-right: 0;
            margin-bottom: 35px;
        }
        .header__tel,
        .header__lk{
            height: 40px;
            width: 40px;
        }
        .burger-ico{
            display: flex;
        }
        .show{
            display: flex;
        }
        .search__field{
            padding: 15px;
        }
        .navigation__item_mob{
            display: block;
        }
    }
</style>